import { blockGQLFields } from './block.js';
export const slateGQLFields = (fields) => `
  rootBlock
  blocks {
    ${blockGQLFields(fields)}
  }
  restrictions {
    nonEditableBlocks
    lockedChildrenBlocks
    nonRemovableBlocks
  }
`;
//# sourceMappingURL=slate.fields.js.map